import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { InventionCheckList, InventionCheckListResponse } from '../models/inventionCheckList.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable({
  providedIn: 'root'
})

export class InventionCheckListService {
  private baseUrl: string;
  private api: string = "api/InventionCheckList";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  private handleErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('InventionCheckList Service Client Side Error: ', errorResponse.error.message);
    } else {
      throw errorResponse;
    }
  }

  async InventionCheckList_CreateAsync(encryptedUser: string, inventionCheckList: InventionCheckListResponse): Promise<InventionCheckListResponse | void> {
    const a = await this.httpClient.post<InventionCheckListResponse>(`${this.baseUrl}/InventionCheckList_Create`, inventionCheckList, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, inventionCheckList, "", encryptedUser, "InventionCheckListService", "InventionCheckList_CreateAsync"); });

    return a;
  }

  async InventionCheckList_GetAsync(encryptedUser: string, inventionId: number, contractSessionId: number): Promise<InventionCheckListResponse | void> {
    const a = await this.httpClient
      .get<InventionCheckListResponse>(`${this.baseUrl}/InventionCheckList_Get/${inventionId}/${contractSessionId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "InventionID - " + inventionId + "ContractSessionId - " + contractSessionId, encryptedUser, "InventionCheckListService", "InventionCheckList_GetAsync"); });

    return a;
  }


}
